import React from 'react';

import { makeStyles, TableRow, TableCell, Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { putMedicacionActiva } from '../../../../actions/hce/hceActions';


const useStyles = makeStyles({
    iconEstado: {
        '&:hover': {
            backgroundColor: '#80808026',
        },
    },
});

const optionsfecha = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
};

export const MedicacionActivaItem = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { medicacion } = props;

    const finalizarMedicacion = (medicacion) => {
        const data = {
            id: medicacion.id,
            fechaFinalizacion: new Date(),
            idAfiliado: medicacion.idAfiliado,
            idAfiliadoExterno: medicacion.idAfiliadoExterno

        }
        dispatch(putMedicacionActiva(data))
    }

    return (
        <>
            <TableRow className={classes.iconEstado}>
                <TableCell>
                    {medicacion?.problema === '' ? '' : medicacion.problema}
                </TableCell>
                <TableCell>
                    {medicacion?.nombreMed === '' ? '' : medicacion.nombreMed}
                </TableCell>
                <TableCell>
                    {medicacion?.indicacion === '' ? '' : medicacion.indicacion}
                </TableCell>
                <TableCell>
                    {medicacion?.cantidad === ''
                        ? ''
                        : medicacion.cantidad}
                </TableCell>
                <TableCell>
                    {medicacion?.dosis === ''
                        ? ''
                        : medicacion.dosis}
                </TableCell>
                <TableCell>
                    {medicacion?.indicacion === ''
                        ? ''
                        : medicacion.indicacion}
                </TableCell>
                <TableCell>
                    {medicacion?.posologia === ''
                        ? ''
                        : medicacion.posologia}
                </TableCell>
                <TableCell>
                    {medicacion?.tratamientoProlongado === true
                        ? 'SI'
                        : 'NO'}
                </TableCell>
                <TableCell>
                    {medicacion?.fechaFinalizacion ? new Date(medicacion?.fechaFinalizacion).toLocaleString('es', optionsfecha) : ''}
                </TableCell>
                <TableCell>
                    {medicacion?.nombreMedico === ''
                        ? ''
                        : medicacion.nombreMedico}
                </TableCell>
                <TableCell>
                    {medicacion?.descripcionEspecialidad === ''
                        ? ''
                        : medicacion.descripcionEspecialidad}
                </TableCell>
                {medicacion?.fechaFinalizacion === null && (
                    <TableCell>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => finalizarMedicacion(medicacion)}
                        >
                            Finalizar
                        </Button>
                    </TableCell>
                )}
            </TableRow>
        </>
    )
}
